(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('licensesDao', ["http", function (http) {
        var licensesDao = {
            getLicenses: function () {
                return http.get('/api/v1/licenses');
            }
        };
        return licensesDao;
    }]);
}());